export const CameraType = {
    CAMERA_ROAD: 'CAMERA_ROAD',
    CAMERA_CABIN: 'CAMERA_CABIN',
    CAMERA_AUTO: 'CAMERA_AUTO',
    0: 'CAMERA_AUTO',
    1: 'CAMERA_ROAD',
    2: 'CAMERA_CABIN',
};

export const MediaType = {
    MEDIA_SHORT: 'MEDIA_SHORT',
    MEDIA_PREVIEW: 'MEDIA_PREVIEW',
    MEDIA_PREVIEW_VIDEO: 'MEDIA_PREVIEW_VIDEO',
    MEDIA_PREVIEW_FACE: 'MEDIA_PREVIEW_FACE',
    MEDIA_STREAMING_ARCHIVE: 'MEDIA_STREAMING_ARCHIVE',
}
